import FreeCardsBg from '@shared/assets/parts/FreeCardsBg';

export default function FreeCardsBadge({ text }) {
  return (
    <div className="free-cards">
      <FreeCardsBg />
      {text}
    </div>
  );
}
